import { createMuiTheme } from '@material-ui/core/styles';
import config from '../run-config';

const theme = createMuiTheme({
  typography: {
    htmlFontSize: 15,
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: config.primary,
      contrastText: config.primaryText,
    },
    secondary: { main: config.secondary },
    link: { main: config.link },
  },
});

export default theme;
